import React, { Component } from 'react';
import { Table, Button } from 'react-bootstrap';
import { pencil2 } from 'react-icons-kit/icomoon/pencil2';
import swal from 'sweetalert';
import { translate } from 'react-i18next';
import SvgIcon from 'react-icons-kit';
import ModalAuthorization from './ModalAuthorization';

var Config = require('../../../config');
class TableRefuses extends Component{
	constructor(props){
		super(props);

		this.removeRefuse = this.removeRefuse.bind(this);
		this.editAuth     = this.editAuth.bind(this);

		this.state= {
			id_refuse:"",
			columns:[]
		}

	}

	componentDidMount(){
		this.props.onRef(this);

		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=REFUSE_INCIDENTS',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => {
      		if(response.ok){
      			return response.json();
      		}else{
      			response.text().then((msg)=>{
      				swal('Error', msg, 'error');
      			});
      		}   		
      	}).then(response => {
        	if(response !== undefined){

          		this.setState({ columns: response });
        	}
      	});
	}

	componentWillMount(){
		this.props.onRef(null);
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	reformatDate(fecha){
		fecha = fecha.split('T')[0];

		fecha = fecha.split('-').reverse().join('/');

		return fecha;
	}

	//autorizacion de liberacion de candado
	editAuth(){
		this.modal_authorization.handleShow();
	}

	removeRefuse(id, i){
		this.setState({
			id_refuse:""
		});

		var msg = '¿Desea quitar el candado?';
		if(this.props.refuses[i].reactive_results.length > 0){
			msg = 'Se va a liberar a un donador con pruebas: ';
			this.props.refuses[i].reactive_results.map((r, j)=>
				msg += r+(j === this.props.refuses[i].reactive_results.length -1 ? '' : ', ')
			);
		}
		
		swal({
	        title: 'Confirmación',
	        text: msg,
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Quitar!',
	        cancelButtonText: '¡No, Cancelar!',
	        //closeOnConfirm: true,
	        closeOnCancel: true
	    }, function(isConfirm){
			if(isConfirm === true){
				this.setState({
					id_refuse:id
				})
				
				this.editAuth();
				
			}
		}.bind(this));
	}

	render(){
		const { t } = this.props;
		return (
			<div className="col-xs-12" style={{paddingLeft:"1em"}}>
				<Table responsive hover>
					<thead>
						<tr>
							<th hidden={this.showColumn('DONOR')}>{t('content.refuses.table.offer')}</th>
							<th hidden={this.showColumn('REFUSE_REASON')}>{t('content.refuses.table.reason')}</th>
							<th hidden={this.showColumn('INCIDENT_DATE')}>{t('content.refuses.table.date')}</th>
							<th hidden={this.showColumn('PERIOD')}>{t('content.refuses.table.period')}</th>
							<th hidden={this.showColumn('CONTROLS')}></th>
						</tr>
					</thead>
					<tbody>
					{ this.props.refuses.map((r, i)=>(
						
							<tr key={i}>
								<td hidden={this.showColumn('DONOR')}>{r.donor_name}</td>
								<td hidden={this.showColumn('REFUSE_REASON')}>{r.incidents.reason}</td>
								<td hidden={this.showColumn('INCIDENT_DATE')}>{ this.reformatDate(r.incidents.date_refused) }</td>
								<td hidden={this.showColumn('PERIOD')}>{r.incidents.period}</td>
								<td hidden={this.showColumn('CONTROLS')}>
									<Button className="btn btn-info btn-xs" title="Editar" 
										onClick={this.removeRefuse.bind(this, r.incidents.id, i)}
										disabled={!this.props.task_release_lock.update}
									>
									{/*<Button className="btn btn-info btn-xs" title="Editar" onClick={this.editAuth}>*/}
										<SvgIcon icon={pencil2} />
									</Button>
								</td>
							</tr>
						
					))

					}
					</tbody>
				</Table>

				<ModalAuthorization {...this.props} 
					id_refuse={this.state.id_refuse} 
					onRef={ref => (this.modal_authorization = ref)} />
			</div>
		);
	}
}

export default translate('translations')(TableRefuses);